import { render } from "./LeaveApply.vue?vue&type=template&id=2ecfa3c1&scoped=true"
import script from "./LeaveApply.vue?vue&type=script&lang=js"
export * from "./LeaveApply.vue?vue&type=script&lang=js"

import "./LeaveApply.vue?vue&type=style&index=0&id=2ecfa3c1&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecfa3c1"]])

export default __exports__